"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
  mutation sharingTicket($params: SharingInput!) {
  sharingTicket(params: $params) {
    _id
  }
}
`;
exports.default = mutation;
//# sourceMappingURL=sharingTicket.mutation.js.map